import { CustomEdge, CustomNode } from '@src/components/custom-nodes/types';
import { NODES_GAP, NODE_HEIGHT } from '@src/consts';

export const recalculateNodesYPosForNodes = (nodes: CustomNode[], edges: CustomEdge[]) => {
  const startingNode = nodes.find((node) => node.type === 'StartNode');

  // The editor deserializes as soon as React Flow is ready, which can be before
  // the host app has loaded the scenario: nothing to lay out yet (LF360-2031).
  if (!startingNode) {
    return;
  }

  if (!startingNode.position) {
    startingNode.position = { x: 0, y: 0 };
  }

  function setNestedNodesByParentNode(parentNode: CustomNode) {
    const edgesWithParentNodeAsSource = edges.filter((edge) => edge.source === parentNode.id);
    const targetNodes = nodes.filter((node) => edgesWithParentNodeAsSource.map((edge) => edge.target).includes(node.id));
    targetNodes.forEach((node) => {
      const getOtherEdgesWithNodeAsTarget = edges.filter((edge) => edge.target === node.id);
      const resolvedNodes = nodes.filter((node) => getOtherEdgesWithNodeAsTarget.map((edge) => edge.source).includes(node.id));

      if (!node.position) {
        node.position = { x: 0, y: 0 };
      }

      node.position.y = Math.max(...resolvedNodes.map(node => node?.position?.y ?? 0)) + NODES_GAP + Math.max(...resolvedNodes.map(node => node.height ?? NODE_HEIGHT));
      setNestedNodesByParentNode(node);
    });
  }

  setNestedNodesByParentNode(startingNode);
}
